module.exports = __webpack_public_path__ + "static/img/0000智慧校园2.9e564c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000智慧校园2.jpg
// module id = DIxT
// module chunks = 0